import styled from '@emotion/styled';
import { ReactComponent as LogoImage } from '@/assets/logo-dark.svg';
import { ReactComponent as HeartLogoSvg } from '@/assets/logo-heart.svg';

export const Logo = styled(LogoImage)`
  display: none;
  width: 100%;
  max-width: 256px;
  @media (min-width: 800px) {
    display: block;
  }
`;

export const HeartLogo = styled(HeartLogoSvg)`
  position: relative;
  z-index: 2;
  width: 31px;
  height: 25px;
  @media (min-width: 800px) {
    display: none;
  }
`;
